import { Box, CircularProgress, IconButton, Typography, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FixedBottomBar, HeaderBox } from './MobileBookPage'; 
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useTranslation } from 'react-i18next';
import KalyansServices from '../../Services/Kalyan'; 
import KalpataruServices from '../../Services/Kalpataru'; // Assuming you have this service
import { Product } from './MobileMagazines';

const MobileKalyansPage = () => {
    const navigate = useNavigate();
    const { t,i18n } = useTranslation();
    const FIXED_BOTTOM_BAR_HEIGHT = 56;
    const [kalyanBooks, setKalyanBooks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalRecords, setTotalRecords] = useState(0);
    const location:any = useLocation();
    // Determine if it's Kalyan or Kalpataru based on location state
    const isKalpataru = location?.state?.productId === Product.KalyanKalpataru;
    // const currentLanguage = i18n.language;
    const currentLanguage :any = localStorage.getItem("lan")
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                let response;
                if (isKalpataru) {
                    // Call Kalpataru API if productId matches
                    response = await KalpataruServices.getCategories(currentLanguage);
                } else {
                    // Default to Kalyan API
                    response = await KalyansServices.getCategories(currentLanguage);
                }

                if (response.status && response.result) {
                    const mappedData = response?.result?.map((item:any) => ({
                        id: item.edition,
                        title: item.name,
                        year: item.years,
                        image: item.categoryPath,
                        objId: item.id,
                        language: item.language 
                    }
                
                ));
                    setKalyanBooks(mappedData);
                    setTotalRecords(response.result.totalRecords);
                } else {
                    console.error(`Failed to fetch ${isKalpataru ? 'Kalpataru' : 'Kalyan'} categories:`, response.message);
                    setKalyanBooks([]);
                    setTotalRecords(0);
                }
            } catch (error) {
                console.error(`Error fetching ${isKalpataru ? 'Kalpataru' : 'Kalyan'} categories:`, error);
                setKalyanBooks([]);
                setTotalRecords(0);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [isKalpataru]); // Re-run effect if isKalpataru changes

    const handleNavigate = (kalyansId:any, language:any,isKalpataruBook:boolean, kalyanName?:string) => {
        navigate("/books", { state: { kalyansId: kalyansId, kalyansLanguage: language,isKalpataruBook:isKalpataruBook, kalyanName: kalyanName} });
    };

    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
                <HeaderBox>
                    <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}>
                        <ArrowBackIosIcon sx={{ color: "white", fontSize: '18px' }} />
                    </IconButton>
                    <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}>
                        <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
                    </IconButton>
                    <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
                        {t("shrihari_tr")}
                    </Typography>
                    <Typography variant="h6" sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}>
                        {isKalpataru ? t("Kalpataru_lang_tr") : t("Kalyan_lang_tr")} {/* Dynamic Header */}
                    </Typography>
                </HeaderBox>
                <Box sx={{
                    backgroundColor: '#f0f0f0',
                    padding: '4px 8px',
                    textAlign: 'left',
                }}>
                    <Typography variant="body2" sx={{ color: '#555', textAlign: 'center' }}>
                        {t("Total_Records_tr")}: {totalRecords}
                    </Typography>
                </Box>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexGrow: 1 }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box
                        sx={{
                            backgroundColor: "whitesmoke",
                            flexGrow: 1,
                            overflowY: 'auto',
                            scrollbarWidth: "none",
                            msOverflowStyle: "none",
                            padding: '8px',
                            paddingBottom: `${FIXED_BOTTOM_BAR_HEIGHT + 16}px`,
                        }}
                    >
                        <Grid container spacing={1} sx={{ justifyContent: 'center' }}>
                            {kalyanBooks.map((kalyans:any) => (
                                <Grid item xs={4} sm={4} md={3} lg={2} key={kalyans.id}>
                                    <Box onClick={() => { handleNavigate(kalyans?.objId, kalyans?.language,isKalpataru, kalyans?.title) }} sx={{
                                        backgroundColor: 'white',
                                        padding: '8px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        height: '100%',
                                        position: 'relative'
                                    }}>
                                        <Box sx={{
                                            position: 'absolute',
                                            top: 0,
                                            left: '50%',
                                            transform: 'translateX(-50%)',
                                            backgroundColor: '#ff9800',
                                            color: 'white',
                                            borderRadius: '0 0 8px 8px',
                                            padding: '2px 8px',
                                            fontSize: '0.7rem',
                                            fontWeight: 'bold',
                                            zIndex: 1
                                        }}>
                                            {kalyans.id}
                                        </Box>
                                        <Box sx={{ mt: 2 }}>
                                            <img
                                                src={kalyans.image}
                                                alt={kalyans.title}
                                                style={{
                                                    width: '100%',
                                                    height: '101px',
                                                    maxWidth: '120px',
                                                    maxHeight: '160px',
                                                    objectFit: 'contain',
                                                    marginBottom: '8px',
                                                    border: '1px solid #eee'
                                                }}
                                            />
                                        </Box>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#333', fontSize: '1.1rem', lineHeight: 1, fontFamily: 'chanakyaUni' }}>
                                            {kalyans.title}
                                        </Typography>
                                        <Typography variant="caption" className='pt-2' sx={{ color: '#f97316', fontSize: '0.95rem', fontWeight: 600, fontFamily: 'chanakyaUni' }}>
                                            वर्ष: {kalyans.year}
                                        </Typography>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                )}
                <Box
                    sx={{
                        position: 'sticky',
                        bottom: 0,
                        width: '100%',
                        zIndex: 100,
                    }}
                >
                    {/* <FixedBottomBar /> */}
                </Box>
            </Box>
        </>
    );
}

export default MobileKalyansPage;